/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export class HttpClient {
  baseUrl = "";
  securityData = null;
  securityWorker;
  abortControllers = new Map();
  customFetch = (...fetchParams) => fetch(...fetchParams);
  baseApiParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };
  constructor(apiConfig = {}) {
    Object.assign(this, apiConfig);
  }
  setSecurityData = (data) => {
    this.securityData = data;
  };
  encodeQueryParam(key, value) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }
  addQueryParam(query, key) {
    return this.encodeQueryParam(key, query[key]);
  }
  addArrayQueryParam(query, key) {
    const value = query[key];
    return value.map((v) => this.encodeQueryParam(key, v)).join("&");
  }
  toQueryString(rawQuery) {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter(
      (key) => "undefined" !== typeof query[key],
    );
    return keys
      .map((key) =>
        Array.isArray(query[key])
          ? this.addArrayQueryParam(query, key)
          : this.addQueryParam(query, key),
      )
      .join("&");
  }
  addQueryParams(rawQuery) {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }
  contentFormatters = {
    ["application/json"]: (input) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    ["application/vnd.api+json"]: (input) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    ["text/plain"]: (input) =>
      input !== null && typeof input !== "string"
        ? JSON.stringify(input)
        : input,
    ["multipart/form-data"]: (input) => {
      if (input instanceof FormData) {
        return input;
      }
      return Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
              ? JSON.stringify(property)
              : `${property}`,
        );
        return formData;
      }, new FormData());
    },
    ["application/x-www-form-urlencoded"]: (input) => this.toQueryString(input),
  };
  mergeRequestParams(params1, params2) {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }
  createAbortSignal = (cancelToken) => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }
    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };
  abortRequest = (cancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);
    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };
  request = async ({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }) => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || "application/json"];
    const responseFormat = format || requestParams.format;
    return this.customFetch(
      `${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`,
      {
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type && type !== "multipart/form-data"
            ? { "Content-Type": type }
            : {}),
        },
        signal:
          (cancelToken
            ? this.createAbortSignal(cancelToken)
            : requestParams.signal) || null,
        body:
          typeof body === "undefined" || body === null
            ? null
            : payloadFormatter(body),
      },
    ).then(async (response) => {
      const r = response;
      r.data = null;
      r.error = null;
      const responseToParse = responseFormat ? response.clone() : response;
      const data = !responseFormat
        ? r
        : await responseToParse[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });
      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }
      return data;
    });
  };
}
/**
 * @title Portal Gateway
 * @version 13.2.0
 * @contact
 *
 * This service acts as an API gateway to integrate our backend services for our portal frontend.
 *
 * Generated API specifications can be found here:
 * [JSON](/portal-gateway/api-docs-json)
 * [YAML](/portal-gateway/api-docs-yaml)
 */
export class Api {
  http;
  constructor(http) {
    this.http = http;
  }
  ai = {
    /**
     * @description Proxies portal-api `POST /api/v2/documents/download` with the current user JWT and the same download filters as document chat (userview / mandatory filters when present). No contentId.
     *
     * @tags ai
     * @name DownloadAiAssistantDocument
     * @summary Download a cited document for the AI assistant preview
     * @request GET:/portal-gateway/v1/tenant/ai/documents/{documentId}/download
     * @secure
     */
    downloadAiAssistantDocument: (documentId, query, params = {}) =>
      this.http.request({
        path: `/portal-gateway/v1/tenant/ai/documents/${documentId}/download`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),
    /**
     * No description
     *
     * @tags ai
     * @name ChatWithDocument
     * @summary Start or continue an AI chat session with a document
     * @request POST:/portal-gateway/v1/tenant/ai/{contentId}/documents/{documentId}/chat
     * @secure
     */
    chatWithDocument: (contentId, documentId, data, params = {}) =>
      this.http.request({
        path: `/portal-gateway/v1/tenant/ai/${contentId}/documents/${documentId}/chat`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags ai
     * @name ChatWithAiAssistant
     * @summary Start or continue a general AI chat session
     * @request POST:/portal-gateway/v1/tenant/ai/chat
     * @secure
     */
    chatWithAiAssistant: (data, params = {}) =>
      this.http.request({
        path: `/portal-gateway/v1/tenant/ai/chat`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags ai
     * @name ListAiChatSessions
     * @summary List AI chat sessions for the current user
     * @request GET:/portal-gateway/v1/tenant/ai/chat/sessions
     * @secure
     */
    listAiChatSessions: (query, params = {}) =>
      this.http.request({
        path: `/portal-gateway/v1/tenant/ai/chat/sessions`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags ai
     * @name GetAiChatSessionHistory
     * @summary Get message history for an AI chat session
     * @request GET:/portal-gateway/v1/tenant/ai/chat/sessions/{sessionId}
     * @secure
     */
    getAiChatSessionHistory: (sessionId, query, params = {}) =>
      this.http.request({
        path: `/portal-gateway/v1/tenant/ai/chat/sessions/${sessionId}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags ai
     * @name DeleteAiChatSession
     * @summary Delete an AI chat session
     * @request DELETE:/portal-gateway/v1/tenant/ai/chat/sessions/{sessionId}
     * @secure
     */
    deleteAiChatSession: (sessionId, params = {}) =>
      this.http.request({
        path: `/portal-gateway/v1/tenant/ai/chat/sessions/${sessionId}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  table = {
    /**
     * No description
     *
     * @tags table
     * @name PutCustomization
     * @summary Creates or updates customization by content id.
     * @request PUT:/portal-gateway/v1/tenant/tables/{contentId}/customization
     * @secure
     */
    putCustomization: (contentId, data, params = {}) =>
      this.http.request({
        path: `/portal-gateway/v1/tenant/tables/${contentId}/customization`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags table
     * @name GetCustomization
     * @summary Returns table customization by content id.
     * @request GET:/portal-gateway/v1/tenant/tables/{contentId}/customization
     * @secure
     */
    getCustomization: (contentId, params = {}) =>
      this.http.request({
        path: `/portal-gateway/v1/tenant/tables/${contentId}/customization`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags table
     * @name DeleteCustomization
     * @summary Deletes customization by content id.
     * @request DELETE:/portal-gateway/v1/tenant/tables/{contentId}/customization
     * @secure
     */
    deleteCustomization: (contentId, params = {}) =>
      this.http.request({
        path: `/portal-gateway/v1/tenant/tables/${contentId}/customization`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),
    /**
     * @description Download an export of a tables data as an excel file
     *
     * @tags table
     * @name DownloadTableExcelExport
     * @summary Download an export of a tables data as an excel file
     * @request POST:/portal-gateway/v1/tenant/tables/{contentId}/excel-export
     * @secure
     */
    downloadTableExcelExport: (contentId, query, data, params = {}) =>
      this.http.request({
        path: `/portal-gateway/v1/tenant/tables/${contentId}/excel-export`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),
    /**
     * @description Download the static file configured for a table. The response uses the configured download filename (or "Document" when unset) concatenated with an extension derived from the upstream Content-Type. The original uploaded basename is never exposed.
     *
     * @tags table
     * @name DownloadTableStaticFile
     * @summary Download the configured static file for a table
     * @request GET:/portal-gateway/v1/tenant/tables/{contentId}/static-file-download
     * @secure
     */
    downloadTableStaticFile: (contentId, params = {}) =>
      this.http.request({
        path: `/portal-gateway/v1/tenant/tables/${contentId}/static-file-download`,
        method: "GET",
        secure: true,
        ...params,
      }),
    /**
     * @description Download a ZIP file containing one or more documents at once
     *
     * @tags table
     * @name DownloadDocuments
     * @summary Download a document(s) zip file
     * @request POST:/portal-gateway/v1/tenant/tables/{contentId}/files/bulk-download
     * @secure
     */
    downloadDocuments: (contentId, data, params = {}) =>
      this.http.request({
        path: `/portal-gateway/v1/tenant/tables/${contentId}/files/bulk-download`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags table
     * @name UpdateDocumentReadStatus
     * @summary Update document(s) read status
     * @request PUT:/portal-gateway/v1/tenant/tables/{contentId}/files/read-status
     * @secure
     */
    updateDocumentReadStatus: (contentId, data, params = {}) =>
      this.http.request({
        path: `/portal-gateway/v1/tenant/tables/${contentId}/files/read-status`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags table
     * @name UploadTableZipArchive
     * @summary Uploads a zip archive file with document / meta-data pairs
     * @request POST:/portal-gateway/v1/tenant/tables/{contentId}/files/zip-upload
     * @secure
     */
    uploadTableZipArchive: (contentId, data, params = {}) =>
      this.http.request({
        path: `/portal-gateway/v1/tenant/tables/${contentId}/files/zip-upload`,
        method: "POST",
        body: data,
        secure: true,
        type: "multipart/form-data",
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags table
     * @name UploadTableDocument
     * @summary Uploads a file with document / meta-data pairs
     * @request POST:/portal-gateway/v1/tenant/tables/{contentId}/files/upload
     * @secure
     */
    uploadTableDocument: (contentId, data, params = {}) =>
      this.http.request({
        path: `/portal-gateway/v1/tenant/tables/${contentId}/files/upload`,
        method: "POST",
        body: data,
        secure: true,
        type: "multipart/form-data",
        format: "json",
        ...params,
      }),
    /**
     * @description Generated a signed URL so that the requested file can be downloaded without providing any special request headers. WARNING: This route does not do any form of authorization. It will generate signed URLs for any contentId & fileId. Authorization is delegated to portal-api.
     *
     * @tags table
     * @name GetDocumentDownloadUrl
     * @summary Signed URL for document download
     * @request GET:/portal-gateway/v1/tenant/tables/{contentId}/files/{fileId}/download-url
     * @secure
     */
    getDocumentDownloadUrl: (fileId, contentId, query, params = {}) =>
      this.http.request({
        path: `/portal-gateway/v1/tenant/tables/${contentId}/files/${fileId}/download-url`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
    /**
     * @description Download a file using a signed URL previously created by using the `/download-url` endpoint. WARNING: This route does not do any form of authorization. It will accept any valid signed URLs. Authorization is delegated to portal-api.
     *
     * @tags table
     * @name DownloadDocument
     * @summary Download the requested file
     * @request GET:/portal-gateway/v1/tenant/tables/{contentId}/files/{fileId}/download
     * @secure
     */
    downloadDocument: (contentId, fileId, query, params = {}) =>
      this.http.request({
        path: `/portal-gateway/v1/tenant/tables/${contentId}/files/${fileId}/download`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),
    /**
     * No description
     *
     * @tags table
     * @name GetFooterData
     * @summary Returns table footer data for given content id
     * @request POST:/portal-gateway/v1/tenant/tables/{contentId}/footer
     * @secure
     */
    getFooterData: (contentId, data, params = {}) =>
      this.http.request({
        path: `/portal-gateway/v1/tenant/tables/${contentId}/footer`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags table
     * @name SearchGroupedTableData
     * @summary Returns aggregated group-only table data for a given content id
     * @request POST:/portal-gateway/v1/tenant/tables/{contentId}/grouped
     * @secure
     */
    searchGroupedTableData: (contentId, data, query, params = {}) =>
      this.http.request({
        path: `/portal-gateway/v1/tenant/tables/${contentId}/grouped`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),
    /**
     * @description Uploads a document and extracts metadata using AI based on the provided fields and schema. Returns validated extracted data where values are filtered to only include those that exist in the table modal values.
     *
     * @tags table
     * @name ExtractDocumentMetadataWithAi
     * @summary Extract document metadata using AI
     * @request POST:/portal-gateway/v1/tenant/docview/{contentId}/ai-metadata-extraction
     * @secure
     */
    extractDocumentMetadataWithAi: (contentId, data, params = {}) =>
      this.http.request({
        path: `/portal-gateway/v1/tenant/docview/${contentId}/ai-metadata-extraction`,
        method: "POST",
        body: data,
        secure: true,
        type: "multipart/form-data",
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags table
     * @name GetInvestmentComplianceLimitOptions
     * @summary Returns investment compliance limit dropdown options for one data level.
     * @request GET:/portal-gateway/v1/tenant/tables/{contentId}/investment-compliance/limit-options/{dataLevelIndex}
     * @secure
     */
    getInvestmentComplianceLimitOptions: (
      contentId,
      dataLevelIndex,
      params = {},
    ) =>
      this.http.request({
        path: `/portal-gateway/v1/tenant/tables/${contentId}/investment-compliance/limit-options/${dataLevelIndex}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags table
     * @name GetInvestmentComplianceLimitPreview
     * @summary Returns example rows for one investment compliance limit data level.
     * @request POST:/portal-gateway/v1/tenant/tables/{contentId}/investment-compliance/limit-preview/{dataLevelIndex}
     * @secure
     */
    getInvestmentComplianceLimitPreview: (
      contentId,
      dataLevelIndex,
      query,
      data,
      params = {},
    ) =>
      this.http.request({
        path: `/portal-gateway/v1/tenant/tables/${contentId}/investment-compliance/limit-preview/${dataLevelIndex}`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags table
     * @name SearchTableData
     * @summary Table data by content id.
     * @request POST:/portal-gateway/v1/tenant/tables/{contentId}/search
     * @secure
     */
    searchTableData: (contentId, query, data, params = {}) =>
      this.http.request({
        path: `/portal-gateway/v1/tenant/tables/${contentId}/search`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags table
     * @name GetDataIngestionEntities
     * @summary Returns entities that can be used for data ingestion.
     * @request GET:/portal-gateway/v1/tenant/tables/{contentId}/data-ingestion-entities
     * @secure
     */
    getDataIngestionEntities: (contentId, params = {}) =>
      this.http.request({
        path: `/portal-gateway/v1/tenant/tables/${contentId}/data-ingestion-entities`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags table
     * @name PutFilterCustomization
     * @summary Creates or updates a filter customization by reference
     * @request PUT:/portal-gateway/v1/tenant/tables/{referenceType}/{reference}/filter-customization
     * @secure
     */
    putFilterCustomization: (referenceType, reference, data, params = {}) =>
      this.http.request({
        path: `/portal-gateway/v1/tenant/tables/${referenceType}/${reference}/filter-customization`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags table
     * @name GetFilterCustomization
     * @summary Returns filter customization by reference.
     * @request GET:/portal-gateway/v1/tenant/tables/{referenceType}/{reference}/filter-customization
     * @secure
     */
    getFilterCustomization: (referenceType, reference, params = {}) =>
      this.http.request({
        path: `/portal-gateway/v1/tenant/tables/${referenceType}/${reference}/filter-customization`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags table
     * @name DeleteFilterCustomization
     * @summary Deletes customization by reference.
     * @request DELETE:/portal-gateway/v1/tenant/tables/{referenceType}/{reference}/filter-customization
     * @secure
     */
    deleteFilterCustomization: (referenceType, reference, params = {}) =>
      this.http.request({
        path: `/portal-gateway/v1/tenant/tables/${referenceType}/${reference}/filter-customization`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags table
     * @name SearchTableModalValues
     * @summary Table modal values by content id.
     * @request POST:/portal-gateway/v1/tenant/table-modal-values/{contentId}/search
     * @secure
     */
    searchTableModalValues: (contentId, data, params = {}) =>
      this.http.request({
        path: `/portal-gateway/v1/tenant/table-modal-values/${contentId}/search`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags table
     * @name SearchRelatedDocuments
     * @summary Retrieves related documents for this table or a specific table row
     * @request POST:/portal-gateway/v1/tenant/tables/{contentId}/related-documents
     * @secure
     */
    searchRelatedDocuments: (contentId, data, query, params = {}) =>
      this.http.request({
        path: `/portal-gateway/v1/tenant/tables/${contentId}/related-documents`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),
    /**
     * @description Generated a signed URL so that the requested related document can be downloaded without providing any special request headers. WARNING: This route does not do any form of authorization. It will generate signed URLs for any contentId & fileId. Authorization is delegated to portal-api.
     *
     * @tags table
     * @name GetRelatedDocumentDownloadUrl
     * @summary Signed URL for related document download
     * @request POST:/portal-gateway/v1/tenant/tables/{contentId}/related-documents/{fileId}/download-url
     * @secure
     */
    getRelatedDocumentDownloadUrl: (
      contentId,
      fileId,
      data,
      query,
      params = {},
    ) =>
      this.http.request({
        path: `/portal-gateway/v1/tenant/tables/${contentId}/related-documents/${fileId}/download-url`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),
    /**
     * @description Download a related document using a signed URL previously created by using the `/download-url` endpoint. WARNING: This route does not do any form of authorization. It will accept any valid signed URLs. Authorization is delegated to portal-api.
     *
     * @tags table
     * @name DownloadRelatedDocument
     * @summary Download the requested related document
     * @request GET:/portal-gateway/v1/tenant/tables/{contentId}/related-documents/{fileId}/download
     * @secure
     */
    downloadRelatedDocument: (fileId, contentId, query, params = {}) =>
      this.http.request({
        path: `/portal-gateway/v1/tenant/tables/${contentId}/related-documents/${fileId}/download`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),
    /**
     * No description
     *
     * @tags table
     * @name PatchTableRows
     * @summary Updates multiple table rows at once.
     * @request PATCH:/portal-gateway/v1/tenant/tables/{contentId}/rows
     * @secure
     */
    patchTableRows: (contentId, data, params = {}) =>
      this.http.request({
        path: `/portal-gateway/v1/tenant/tables/${contentId}/rows`,
        method: "PATCH",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags table
     * @name DeleteTableRows
     * @summary Deletes multiple table rows at once.
     * @request DELETE:/portal-gateway/v1/tenant/tables/{contentId}/rows
     * @secure
     */
    deleteTableRows: (contentId, data, params = {}) =>
      this.http.request({
        path: `/portal-gateway/v1/tenant/tables/${contentId}/rows`,
        method: "DELETE",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags table
     * @name PostTableRowData
     * @summary Creates data row.
     * @request POST:/portal-gateway/v1/tenant/tables/{contentId}/row
     * @secure
     */
    postTableRowData: (contentId, data, params = {}) =>
      this.http.request({
        path: `/portal-gateway/v1/tenant/tables/${contentId}/row`,
        method: "POST",
        body: data,
        secure: true,
        type: "multipart/form-data",
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags table
     * @name SearchTableRowModalValues
     * @summary Searches dropdown values used in create & edit table row actions
     * @request POST:/portal-gateway/v1/tenant/tables/{contentId}/row/modal-values/search
     * @secure
     */
    searchTableRowModalValues: (contentId, data, params = {}) =>
      this.http.request({
        path: `/portal-gateway/v1/tenant/tables/${contentId}/row/modal-values/search`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),
    /**
     * @description Downloads data for table rows
     *
     * @tags table
     * @name DownloadTableRows
     * @request POST:/portal-gateway/v1/tenant/tables/{contentId}/row/download
     * @secure
     */
    downloadTableRows: (contentId, data, params = {}) =>
      this.http.request({
        path: `/portal-gateway/v1/tenant/tables/${contentId}/row/download`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),
    /**
     * @description  Executes generic bulk requests for table rows
     *
     * @tags table
     * @name ExecuteRowRequest
     * @request POST:/portal-gateway/v1/tenant/tables/{contentId}/row/request
     * @secure
     */
    executeRowRequest: (contentId, data, params = {}) =>
      this.http.request({
        path: `/portal-gateway/v1/tenant/tables/${contentId}/row/request`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags table
     * @name SearchCustomTableFilterData
     * @summary Custom table filter data by content id.
     * @request POST:/portal-gateway/v1/tenant/custom-table-filter/{contentId}/search
     * @secure
     */
    searchCustomTableFilterData: (contentId, data, params = {}) =>
      this.http.request({
        path: `/portal-gateway/v1/tenant/custom-table-filter/${contentId}/search`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags table
     * @name SearchTableFilterData
     * @summary Table filter data by content id.
     * @request POST:/portal-gateway/v1/tenant/table-filters/{contentId}/search
     * @secure
     */
    searchTableFilterData: (contentId, data, params = {}) =>
      this.http.request({
        path: `/portal-gateway/v1/tenant/table-filters/${contentId}/search`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),
  };
  navigation = {
    /**
     * No description
     *
     * @tags navigation
     * @name GetNavigation
     * @summary User-specific navigation structure
     * @request GET:/portal-gateway/v1/tenant/navigation
     * @secure
     */
    getNavigation: (params = {}) =>
      this.http.request({
        path: `/portal-gateway/v1/tenant/navigation`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags navigation
     * @name PostNavigationCustomization
     * @summary Creates dynamic navigation items for a user & tenant.
     * @request POST:/portal-gateway/v1/tenant/navigation/customization
     * @secure
     */
    postNavigationCustomization: (data, params = {}) =>
      this.http.request({
        path: `/portal-gateway/v1/tenant/navigation/customization`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags navigation
     * @name GetNavigationCustomizations
     * @summary Returns dynamic navigation items for a user & tenant identified by token.
     * @request GET:/portal-gateway/v1/tenant/navigation/customization
     * @secure
     */
    getNavigationCustomizations: (params = {}) =>
      this.http.request({
        path: `/portal-gateway/v1/tenant/navigation/customization`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags navigation
     * @name UpdateNavigationCustomization
     * @summary Updates a dynamic navigation item by id.
     * @request PUT:/portal-gateway/v1/tenant/navigation/customization
     * @secure
     */
    updateNavigationCustomization: (data, params = {}) =>
      this.http.request({
        path: `/portal-gateway/v1/tenant/navigation/customization`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags navigation
     * @name DeleteAllNavigationCustomization
     * @summary Deletes all dynamic navigation item by userId.
     * @request DELETE:/portal-gateway/v1/tenant/navigation/customization/all
     * @secure
     */
    deleteAllNavigationCustomization: (params = {}) =>
      this.http.request({
        path: `/portal-gateway/v1/tenant/navigation/customization/all`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags navigation
     * @name DeleteNavigationCustomization
     * @summary Deletes a dynamic navigation item by id.
     * @request DELETE:/portal-gateway/v1/tenant/navigation/customization/{id}
     * @secure
     */
    deleteNavigationCustomization: (id, params = {}) =>
      this.http.request({
        path: `/portal-gateway/v1/tenant/navigation/customization/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags navigation
     * @name GetUrlMapping
     * @summary Maps a legacy portal path to a portal next url path
     * @request POST:/portal-gateway/v1/tenant/navigation/url-mapping
     * @secure
     */
    getUrlMapping: (data, params = {}) =>
      this.http.request({
        path: `/portal-gateway/v1/tenant/navigation/url-mapping`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),
  };
  workflow = {
    /**
     * No description
     *
     * @tags workflow
     * @name ExecuteWorkflowAction
     * @summary Executes a workflow action for given content and row(s)
     * @request PUT:/portal-gateway/v1/tenant/workflows/{contentId}/actions/{action}
     * @secure
     */
    executeWorkflowAction: (contentId, action, data, params = {}) =>
      this.http.request({
        path: `/portal-gateway/v1/tenant/workflows/${contentId}/actions/${action}`,
        method: "PUT",
        body: data,
        secure: true,
        type: "multipart/form-data",
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags workflow
     * @name InitiateSignature
     * @summary Initiates a signing request for a document
     * @request POST:/portal-gateway/v1/tenant/workflows/{contentId}/sign-requests/documents/{documentId}
     * @secure
     */
    initiateSignature: (documentId, contentId, params = {}) =>
      this.http.request({
        path: `/portal-gateway/v1/tenant/workflows/${contentId}/sign-requests/documents/${documentId}`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags workflow
     * @name GetTransientStateFromWorkflowController
     * @request POST:/portal-gateway/v1/tenant/workflows/{contentId}/transient-state
     * @secure
     */
    getTransientStateFromWorkflowController: (contentId, data, params = {}) =>
      this.http.request({
        path: `/portal-gateway/v1/tenant/workflows/${contentId}/transient-state`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),
  };
  auth = {
    /**
     * No description
     *
     * @tags auth
     * @name GetUserRoles
     * @summary Roles assigned to the current user
     * @request GET:/portal-gateway/v1/tenant/iam/roles
     * @secure
     */
    getUserRoles: (query, params = {}) =>
      this.http.request({
        path: `/portal-gateway/v1/tenant/iam/roles`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  contentLibrary = {
    /**
     * @description Returns configured categories in order, pruned to items that can form a full-path tag combination present on contents the current user can access (content and page ACL). Empty categories are omitted. validPaths lists each distinct tag name combination with contents in category order.
     *
     * @tags content-library
     * @name GetContentLibraryCategories
     * @summary Content library categories
     * @request GET:/portal-gateway/v1/tenant/content-library/categories
     * @secure
     */
    getContentLibraryCategories: (params = {}) =>
      this.http.request({
        path: `/portal-gateway/v1/tenant/content-library/categories`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags content-library
     * @name SearchContentLibraryContents
     * @summary Search content library contents by tags
     * @request POST:/portal-gateway/v1/tenant/content-library/contents/search
     * @secure
     */
    searchContentLibraryContents: (data, params = {}) =>
      this.http.request({
        path: `/portal-gateway/v1/tenant/content-library/contents/search`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),
  };
  page = {
    /**
     * No description
     *
     * @tags page
     * @name GetPage
     * @summary Page with contents
     * @request GET:/portal-gateway/v1/tenant/pages/{id}
     * @secure
     */
    getPage: (id, params = {}) =>
      this.http.request({
        path: `/portal-gateway/v1/tenant/pages/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags page
     * @name GenerateNavItemLabelLines
     * @summary Generate raw detail navigation label lines for a detail page
     * @request POST:/portal-gateway/v1/tenant/pages/{id}/nav-item-label-lines/generate
     * @secure
     */
    generateNavItemLabelLines: (id, data, params = {}) =>
      this.http.request({
        path: `/portal-gateway/v1/tenant/pages/${id}/nav-item-label-lines/generate`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),
  };
  customization = {
    /**
     * No description
     *
     * @tags customization
     * @name GetPersistedFilterSelections
     * @summary Returns persisted filter selections
     * @request GET:/portal-gateway/v1/tenant/persisted-filter-selections/{kind}/{reference}/{setKey}
     * @secure
     */
    getPersistedFilterSelections: (
      kind,
      reference,
      setKey,
      query,
      params = {},
    ) =>
      this.http.request({
        path: `/portal-gateway/v1/tenant/persisted-filter-selections/${kind}/${reference}/${setKey}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags customization
     * @name PutPersistedFilterSelections
     * @summary Creates or updates persisted filter selections
     * @request PUT:/portal-gateway/v1/tenant/persisted-filter-selections/{kind}/{reference}/{setKey}
     * @secure
     */
    putPersistedFilterSelections: (
      kind,
      reference,
      setKey,
      data,
      query,
      params = {},
    ) =>
      this.http.request({
        path: `/portal-gateway/v1/tenant/persisted-filter-selections/${kind}/${reference}/${setKey}`,
        method: "PUT",
        query: query,
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags customization
     * @name DeletePersistedFilterSelections
     * @summary Deletes persisted filter selections
     * @request DELETE:/portal-gateway/v1/tenant/persisted-filter-selections/{kind}/{reference}/{setKey}
     * @secure
     */
    deletePersistedFilterSelections: (
      kind,
      reference,
      setKey,
      query,
      params = {},
    ) =>
      this.http.request({
        path: `/portal-gateway/v1/tenant/persisted-filter-selections/${kind}/${reference}/${setKey}`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  dashboard = {
    /**
     * No description
     *
     * @tags dashboard
     * @name ListDashboards
     * @summary List dashboards for a customizable page
     * @request GET:/portal-gateway/v1/tenant/dashboards
     * @secure
     */
    listDashboards: (query, params = {}) =>
      this.http.request({
        path: `/portal-gateway/v1/tenant/dashboards`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
    /**
     * @description The dashboard owner is always the authenticated user from the JWT. Clients cannot set ownerUserId.
     *
     * @tags dashboard
     * @name CreateDashboard
     * @summary Create a dashboard on a customizable page
     * @request POST:/portal-gateway/v1/tenant/dashboards
     * @secure
     */
    createDashboard: (data, params = {}) =>
      this.http.request({
        path: `/portal-gateway/v1/tenant/dashboards`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),
    /**
     * @description Returns dashboard metadata and contents with WidgetDto hydration (or unavailable markers).
     *
     * @tags dashboard
     * @name GetDashboard
     * @summary Get a hydrated dashboard by id
     * @request GET:/portal-gateway/v1/tenant/dashboards/{dashboardId}
     * @secure
     */
    getDashboard: (dashboardId, params = {}) =>
      this.http.request({
        path: `/portal-gateway/v1/tenant/dashboards/${dashboardId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
    /**
     * @description Validates and hydrates the proposed layout before persisting placement triples to poco-api. Returns the hydrated dashboard.
     *
     * @tags dashboard
     * @name UpdateDashboard
     * @summary Update a dashboard layout and metadata
     * @request PUT:/portal-gateway/v1/tenant/dashboards/{dashboardId}
     * @secure
     */
    updateDashboard: (dashboardId, data, params = {}) =>
      this.http.request({
        path: `/portal-gateway/v1/tenant/dashboards/${dashboardId}`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags dashboard
     * @name DeleteDashboard
     * @summary Delete a dashboard owned by the current user
     * @request DELETE:/portal-gateway/v1/tenant/dashboards/{dashboardId}
     * @secure
     */
    deleteDashboard: (dashboardId, query, params = {}) =>
      this.http.request({
        path: `/portal-gateway/v1/tenant/dashboards/${dashboardId}`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags dashboard
     * @name ListDashboardInstances
     * @summary List dashboard instances for a page
     * @request GET:/portal-gateway/v1/tenant/dashboard-instances
     * @secure
     */
    listDashboardInstances: (query, params = {}) =>
      this.http.request({
        path: `/portal-gateway/v1/tenant/dashboard-instances`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags dashboard
     * @name CreateDashboardInstance
     * @summary Create a dashboard instance on a page
     * @request POST:/portal-gateway/v1/tenant/dashboard-instances
     * @secure
     */
    createDashboardInstance: (query, data, params = {}) =>
      this.http.request({
        path: `/portal-gateway/v1/tenant/dashboard-instances`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags dashboard
     * @name UpdateDashboardInstance
     * @summary Update a dashboard instance order on a page
     * @request PATCH:/portal-gateway/v1/tenant/dashboard-instances/{instanceId}
     * @secure
     */
    updateDashboardInstance: (instanceId, query, data, params = {}) =>
      this.http.request({
        path: `/portal-gateway/v1/tenant/dashboard-instances/${instanceId}`,
        method: "PATCH",
        query: query,
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags dashboard
     * @name DeleteDashboardInstance
     * @summary Delete a dashboard instance from top navigation on a page
     * @request DELETE:/portal-gateway/v1/tenant/dashboard-instances/{instanceId}
     * @secure
     */
    deleteDashboardInstance: (instanceId, query, params = {}) =>
      this.http.request({
        path: `/portal-gateway/v1/tenant/dashboard-instances/${instanceId}`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  dataIngestion = {
    /**
     * No description
     *
     * @tags data-ingestion
     * @name CreateTemplate
     * @summary Create a data-ingestion Excel template
     * @request POST:/portal-gateway/v1/tenant/data-ingestion/{contentId}/create-template
     * @secure
     */
    createTemplate: (contentId, data, params = {}) =>
      this.http.request({
        path: `/portal-gateway/v1/tenant/data-ingestion/${contentId}/create-template`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags data-ingestion
     * @name ParseTemplate
     * @summary Upload and parse a data-ingestion template
     * @request POST:/portal-gateway/v1/tenant/data-ingestion/{contentId}/parse-template
     * @secure
     */
    parseTemplate: (contentId, data, params = {}) =>
      this.http.request({
        path: `/portal-gateway/v1/tenant/data-ingestion/${contentId}/parse-template`,
        method: "POST",
        body: data,
        secure: true,
        type: "multipart/form-data",
        format: "json",
        ...params,
      }),
  };
  tenant = {
    /**
     * No description
     *
     * @tags tenant
     * @name GetInfo
     * @summary Confidential information about the application
     * @request GET:/portal-gateway/v1/tenant/info
     * @secure
     */
    getInfo: (params = {}) =>
      this.http.request({
        path: `/portal-gateway/v1/tenant/info`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags tenant
     * @name GetDataTimestamps
     * @summary Timestamps regarding data refresh and closed quarter
     * @request GET:/portal-gateway/v1/tenant/data-timestamps
     * @secure
     */
    getDataTimestamps: (params = {}) =>
      this.http.request({
        path: `/portal-gateway/v1/tenant/data-timestamps`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags tenant
     * @name UploadZipArchive
     * @summary Globally uploads a zip archive file with document / meta-data pairs
     * @request POST:/portal-gateway/v1/tenant/files/zip-upload
     * @secure
     */
    uploadZipArchive: (data, params = {}) =>
      this.http.request({
        path: `/portal-gateway/v1/tenant/files/zip-upload`,
        method: "POST",
        body: data,
        secure: true,
        type: "multipart/form-data",
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags tenant
     * @name GetMandatoryFilterKeys
     * @summary Mandatory filter keys configured for the tenant
     * @request GET:/portal-gateway/v1/tenant/user-management/mandatory-filter-keys
     * @secure
     */
    getMandatoryFilterKeys: (params = {}) =>
      this.http.request({
        path: `/portal-gateway/v1/tenant/user-management/mandatory-filter-keys`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags tenant
     * @name GetMandatoryFilterKeyLabels
     * @summary Value labels for a tenant mandatory filter key
     * @request GET:/portal-gateway/v1/tenant/user-management/mandatory-filter-key-labels/{key}
     * @secure
     */
    getMandatoryFilterKeyLabels: (key, params = {}) =>
      this.http.request({
        path: `/portal-gateway/v1/tenant/user-management/mandatory-filter-key-labels/${key}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  pageFilter = {
    /**
     * No description
     *
     * @tags page-filter
     * @name SearchCustomPageFilterData
     * @summary Custom Page Filter Data – available & selected values
     * @request POST:/portal-gateway/v1/tenant/pages/{id}/custom-filters/search
     * @secure
     */
    searchCustomPageFilterData: (id, data, params = {}) =>
      this.http.request({
        path: `/portal-gateway/v1/tenant/pages/${id}/custom-filters/search`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags page-filter
     * @name SearchPageFilterData
     * @summary Page Filter Data - available & selected values
     * @request POST:/portal-gateway/v1/tenant/pages/{id}/filters/search
     * @secure
     */
    searchPageFilterData: (id, data, params = {}) =>
      this.http.request({
        path: `/portal-gateway/v1/tenant/pages/${id}/filters/search`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),
  };
  publicApi = {
    /**
     * No description
     *
     * @tags public-api
     * @name GetLoginInfo
     * @request GET:/portal-gateway/v1/public-api/login-info
     */
    getLoginInfo: (params = {}) =>
      this.http.request({
        path: `/portal-gateway/v1/public-api/login-info`,
        method: "GET",
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags public-api
     * @name GetThemeFile
     * @summary Returns files associated with a theme (e.g. images)
     * @request GET:/portal-gateway/v1/public-api/theme-files/{name}
     */
    getThemeFile: (name, params = {}) =>
      this.http.request({
        path: `/portal-gateway/v1/public-api/theme-files/${name}`,
        method: "GET",
        ...params,
      }),
  };
  status = {
    /**
     * No description
     *
     * @tags status
     * @name GetAppInfo
     * @summary Non-confidential information about the running application
     * @request GET:/portal-gateway/v1/status/app-info
     */
    getAppInfo: (params = {}) =>
      this.http.request({
        path: `/portal-gateway/v1/status/app-info`,
        method: "GET",
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags status
     * @name GetServiceHealth
     * @summary Brief overview of service health
     * @request GET:/portal-gateway/v1/status/health
     */
    getServiceHealth: (params = {}) =>
      this.http.request({
        path: `/portal-gateway/v1/status/health`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  fopi = {
    /**
     * No description
     *
     * @tags fopi
     * @name SearchFopiFunds
     * @summary Fund options available for input form-data
     * @request POST:/portal-gateway/v1/tenant/fopi/funds/search
     * @secure
     */
    searchFopiFunds: (query, data, params = {}) =>
      this.http.request({
        path: `/portal-gateway/v1/tenant/fopi/funds/search`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags fopi
     * @name SearchFopiCurrencies
     * @summary Currency options available for input form-data
     * @request POST:/portal-gateway/v1/tenant/fopi/currencies/search
     * @secure
     */
    searchFopiCurrencies: (query, data, params = {}) =>
      this.http.request({
        path: `/portal-gateway/v1/tenant/fopi/currencies/search`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags fopi
     * @name SearchFopiFundShareClasses
     * @summary Share classes options available for input form-data
     * @request POST:/portal-gateway/v1/tenant/fopi/fund-share-classes/search
     * @secure
     */
    searchFopiFundShareClasses: (query, data, params = {}) =>
      this.http.request({
        path: `/portal-gateway/v1/tenant/fopi/fund-share-classes/search`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags fopi
     * @name CreateFopiTableRow
     * @summary Create FOPI table row
     * @request POST:/portal-gateway/v1/tenant/fopi/{contentId}/table-row/create
     * @secure
     */
    createFopiTableRow: (contentId, data, params = {}) =>
      this.http.request({
        path: `/portal-gateway/v1/tenant/fopi/${contentId}/table-row/create`,
        method: "POST",
        body: data,
        secure: true,
        type: "multipart/form-data",
        format: "json",
        ...params,
      }),
  };
}
